module.exports = __webpack_public_path__ + "static/media/poc-table-logo.857e3cd6.svg";